// extracted by mini-css-extract-plugin
export var chatHtmlText = "_te-2";
export var chatLink = "_te-0";
export var chatText = "_te-1";